export default "__VITE_ASSET__DGCYna2___"